import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { DataStateChangeEventArgs } from '@syncfusion/ej2-angular-grids';
import { Observable, Subject } from 'rxjs';
import { map } from 'rxjs/operators';
import { ErrorService } from 'src/app/error.service';
import { GetLocationBO } from './location.modal';

@Injectable({
    providedIn: 'root'
})
export class LocationDateService extends Subject<DataStateChangeEventArgs> {
    constructor(private http: HttpClient, public errorService: ErrorService) {
        super();
    }
    public execute(Loc: GetLocationBO): void {
        this.getLocationFilter(Loc).subscribe(x => super.next(x));
    }
    getLocationFilter(Loc?: GetLocationBO): Observable<DataStateChangeEventArgs> {
        return this.http.post<any>("api/Location/GetLocations", Loc)
            .pipe(map(
                (response: any) =>
                    <any>{
                        result: response['result'],
                        count: response['count']
                    }
            ))
    }
}
